import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import SolutionsPage from './pages/SolutionsPage';
import SolutionDetailPage from './pages/SolutionDetailPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import CaseStudyDetailPage from './pages/CaseStudyDetailPage';
import BlogPage from './pages/BlogPage';

// Admin Components
import AdminLogin from './components/admin/AdminLogin';
import Dashboard from './components/admin/Dashboard';
import CompanyInfoPage from './components/admin/CompanyInfoPage';
import ServicesAdminPage from './components/admin/ServicesPage';
import CaseStudiesAdminPage from './components/admin/CaseStudiesPage';
import ArticlesPage from './components/admin/ArticlesPage';
import ContactsPage from './components/admin/ContactsPage';
import StatsPage from './components/admin/StatsPage';

import { Toaster } from './components/ui/toaster';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-8 h-8 border-4 border-[#ff6b35] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
      
      {/* Services Routes */}
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
      
      {/* Solutions Routes */}
      <Route path="/solutions" element={<SolutionsPage />} />
      <Route path="/solutions/:solutionId" element={<SolutionDetailPage />} />
      
      {/* Blog */}
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPage />} />
      
      {/* Case Studies */}
      <Route path="/case-studies" element={<CaseStudiesPage />} />
      <Route path="/case-studies/:caseStudyId" element={<CaseStudyDetailPage />} />
      
      {/* Admin Routes - Hidden from main site navigation */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/company" element={<ProtectedRoute><CompanyInfoPage /></ProtectedRoute>} />
      <Route path="/admin/services" element={<ProtectedRoute><ServicesAdminPage /></ProtectedRoute>} />
      <Route path="/admin/case-studies" element={<ProtectedRoute><CaseStudiesAdminPage /></ProtectedRoute>} />
      <Route path="/admin/articles" element={<ProtectedRoute><ArticlesPage /></ProtectedRoute>} />
      <Route path="/admin/contacts" element={<ProtectedRoute><ContactsPage /></ProtectedRoute>} />
      <Route path="/admin/stats" element={<ProtectedRoute><StatsPage /></ProtectedRoute>} />
      <Route path="/admin/team" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/partners" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/testimonials" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute><StatsPage /></ProtectedRoute>} />
      
      {/* Fallback */}
      <Route path="*" element={<HomePage />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
